import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAddTeamMutation } from "../../features/teams/teamsApi";
import { controlTeamModal } from "../../features/teams/teamsSlice";
import getColor from "../../utils/colors";

export default function Modal({ open }) {
  //Dispatcher
  const dispatch = useDispatch();

  //initial Variables
  const { user: loggedInUser } = useSelector((state) => state.auth) || {};
  const { email: myEmail } = loggedInUser || {};

  //Variables
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");

  //Queries
  const [addTeam] = useAddTeamMutation();

  const debounceHandler = (fn, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  };

  const doSearch = (value) => {
    setName(value);
  };

  const handleNameSearch = debounceHandler(doSearch, 500);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addTeam({
      data: {
        creator: myEmail,
        name: name,
        title: title,
        color: getColor(),
        date: new Date().getTime(),
        members: myEmail,
      },
    });
    dispatch(controlTeamModal());
  };

  return (
    open && (
      <>
        <div
          onClick={() => {
            dispatch(controlTeamModal());
            setName("");
            setTitle("");
          }}
          className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
        ></div>
        <div className="rounded w-[400px] lg:w-[600px] space-y-8 bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Add Team
          </h2>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <input
                  name="name"
                  type="text"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Name"
                  onChange={(e) => handleNameSearch(e.target.value)}
                />
              </div>
              <div>
                <input
                  name="title"
                  type="text"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                // disabled={
                //   conversation === undefined ||
                //   (participant?.length > 0 && participant[0].email === myEmail)
                // }
              >
                Add Team
              </button>
            </div>

            {/* {participant?.length === 0 && (
              <Error message="This user does not exist!" />
            )}
            {participant?.length > 0 && participant[0].email === myEmail && (
              <Error message="You can not send message to yourself!" />
            )} */}

            {/* <Error message="Error" /> */}
          </form>
        </div>
      </>
    )
  );
}
